import React from 'react';
import {
  ApiDocsConfig,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import { SwaggerPostmanDefinition } from './SwaggerPostmanDefinition';

export function createApiDocsConfig(): ApiDocsConfig {
  const widgets = defaultDefinitionWidgets();
  return {
    getApiDefinitionWidget: entity => {
      const widget = widgets.find(item => item.type === entity.spec.type);
      if (!widget || entity.spec.type !== 'openapi') return widget;
      return {
        ...widget,
        component: definition => (
          <SwaggerPostmanDefinition key={definition} definition={definition} />
        ),
      };
    },
  };
}
